import FullInfoField from 'components/FullInfoField/FullInfoField';
import React from 'react';
import { IRestaurantLocalizationItem } from 'types';
import style from './LocalizationItem.module.scss';

interface ILocalizationItem {
	itemData: IRestaurantLocalizationItem;
	languageId: string;
}

const LocalizationItem: React.FC<ILocalizationItem> = ({ itemData, languageId }) => {
	const translationData = itemData.translations.find((el) => el.languageId === languageId);

	return (
		<FullInfoField
			containerClassName={style.container}
			label={itemData.key}
			value={translationData?.value}
			translationNameSpace="localizationSettings"
		/>
	);
};

export default LocalizationItem;
